import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['file'];

  connect() {
    if (!this.hasFileTarget) return;

    // Replacing the history entry keeps Back from returning to this page, which would open the file again.
    const href = this.fileTarget.querySelector('a')?.href;
    if (href) window.location.replace(href);
  }
}
